import { useAppContext } from '@frx/frx-react-context';

export const useTeamsAllowed = (): boolean => {
  const {
    data: {
      eventData: { eventConfig },
    },
  } = useAppContext();

  return eventConfig?.teamsAllowed || false;
};
